package org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings

/**
 * Software update type, defines update stability
 */
enum class AnprDeviceUpdateReleaseType(val value: Int) {
    STABLE(0),    // version safe to be used by all customers
    BETA(1),     // version suitable to be tested by beta customers
    ALPHA(2)    // latest release aimed for internal testing
}